import style from "../../assets/scss/components/content/badge.module.scss"

export default function Badge({background, value}) {
  return (
    <div className={style.badge + ' ' + style[background]}>
      {value}
    </div>
  )
}
